import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { AzureDevOpsClient } from '../httpClients/AzureDevOpsClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';
import type { MasterAppConsentStartRequest } from '../httpClients/AzureDevOpsClient/api.schema';

export const useStartMasterAppConsentMutation = () => {
  return useMutation({
    mutationKey: [MUTATION_KEYS.START_MASTER_APP_CONSENT],
    mutationFn: async (params: MasterAppConsentStartRequest) => {
      return await AzureDevOpsClient.startMasterAppConsent(params);
    },
    onError: (err: any) => {
      const errorMessage = getErrorToastContent(
        err,
        'Failed to start consent flow. Please try again.',
      );

      toast.error(errorMessage);
    },
  });
};
